<template>
  <div class="container">
    <div class="row">
      <div v-if="description" class="col-md-7" v-html="description"></div>
      <div :class="description ? ['col-md-4', 'offset-md-1'] : 'col'">
        <div class="row" v-for="question in questions" v-bind:key="question.id">
          <div
            v-if="question.label"
            class="col-md-7"
            v-html="question.label"
          ></div>
          <div v-if="question.description" class="col-12">
            <p v-html="question.description"></p>
          </div>
          <div class="col-md-5 d-flex justify-content-end pe-0">
            <p v-if="question.variant1" class="hand-written">
              {{ question.variant1 }}
            </p>
            <p v-if="question.variant2">{{ question.variant2 }}</p>
            <div :class="[description ? 'justify-content-around' : '', 'row']">
              <div class="col">
                <div
                  class="form-check form-check-inline"
                  v-for="(choice, index) in question.choices"
                  :key="question.id * 100 + index"
                >
                  <input
                    :id="`radio-${question.id}-${index}`"
                    class="form-check-input my-auto"
                    type="radio"
                    :name="'radio-group-' + question.id"
                    v-model="question.response"
                    :value="choice"
                    v-on:change="handleInputCompleted"
                  />
                  <label
                    class="form-check-label"
                    :for="`radio-${question.id}-${index}`"
                    >{{ choice }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChoiceHorizontal'
}
</script>
